export default __webpack_public_path__ + "static/media/iphone-11.e106b212.png";